// Brand colours live here rather than at the call site, same as Checkbox.ts: Chakra stock renders blue, the brand is
// `primary.midGrey`. The radio stays a circle, so it keeps `borderRadius: "full"` instead of the checkbox's 2px.
export const Radio = {
  baseStyle: {
    control: {
      bg: "none",
      border: "1px solid",
      borderColor: "border.lightest",
      borderRadius: "full",
      _before: {
        height: "70% !important",
        width: "70% !important",
      },
      _checked: {
        bg: "primary.white",
        borderColor: "primary.midGrey",
        color: "primary.midGrey",
        _hover: {
          bg: "primary.white",
          borderColor: "primary.midGrey",
        },
        // Nested inside `_checked` because Chakra's own `_checked._disabled` (gray.200 chrome, gray.500 dot) outranks a
        // flat `_disabled`. `color` drives the dot, which `_before` paints with `currentColor`.
        _disabled: {
          bg: "grey.lightest",
          borderColor: "border.lightest",
          color: "text.disabled",
          opacity: 1,
        },
      },
      // One red across the whole form system, matching `inputChrome._invalid`.
      _invalid: {
        borderColor: "system.error",
      },
      _focus: {
        boxShadow: "0 0 0 2px var(--chakra-colors-system-focus)",
      },
      // Chakra's default `_disabled` is `opacity: 0.4`, which washes out the specified colours. Pinned to 1.
      _disabled: {
        bg: "grey.lightest",
        borderColor: "border.lightest",
        opacity: 1,
      },
    },
    label: {
      _invalid: {
        color: "system.error",
      },
      _disabled: {
        color: "text.disabled",
        opacity: 1,
      },
    },
  },
  // 12px label across every size, matching Checkbox.ts and the rest of the forms. Chakra's stock size recipes set the
  // label font size, so `md` (the default) must be overridden here rather than relying on the call site passing a size.
  sizes: {
    md: {
      label: {
        fontSize: "xs",
      },
    },
    lg: {
      label: {
        fontSize: "xs",
      },
    },
  },
}
